import "./index.css";
import ReactDOM from "react-dom";
import React, { useState } from "react";
import metaMaskIcon from "./images/metamaskIcon.png";
import coinbaseIcon from "./images/coinbaseIcon.png";
import phantomIcon from "./images/phantomIcon.png";
import fortmaticIcon from "./images/fortmaticIcon.png";
import nftbeeLogo from "./images/nftbeeLogo.svg";
import QRCodeSVG from "qrcode.react";
import PhantomWallet from "./PhantomWallet";
import CoinBaseWallet from "./CoinBaseWallet";
import { FortmaticConnector } from "@web3-react/fortmatic-connector";
import MetaMaskWallet from "./MetaMaskWallet";

function App() {
  const [connectMetaMask, setConnectMetaMask] = useState(false);
  const [connectCoinBase, setConnectCoinBase] = useState(false);
  const [connectPhantom, setConnectPhantom] = useState(false);
  const [accountsData, setAccountsData] = useState("");

  const setData = (name, address) => {
    setAccountsData(
      JSON.stringify({
        name,
        address,
      })
    );
  };

  const connectFortmatic = async () => {
    const connector = new FortmaticConnector({
      apiKey: "pk_live_DDB68F4C0CA91949",
      chainId: 1,
    });

    await connector.activate();
    const account = await connector.getAccount();

    setData("Fortmatic", account);

    connector.deactivate();
    localStorage.clear();
  };

  const renderWallet = (imageUrl, name, onClick) => (
    <div className="walletBox" onClick={onClick}>
      <div style={{ width: "40px", height: "40px", padding: "8px", backgroundColor: "#533bc930", borderRadius: "50%" }}>
        <img src={imageUrl} alt={name} />
      </div>
      <p className="content">{name}</p>
    </div>
  );

  return (
    <div className="container">
      <div>
        <img src={nftbeeLogo} className="logo" alt="NFTBee Logo" />
      </div>

      <div className="authenticateContainer">
        <div className="walletSection">
          <h2 className="heading">Authenticate Wallet</h2>
          <div  className="walletList">
            {renderWallet(metaMaskIcon, "MetaMask", () => {
              setAccountsData("");
              setConnectMetaMask(true);
            })}
            {renderWallet(coinbaseIcon, "CoinBase", () => {
              setAccountsData("");
              setConnectCoinBase(true);
            })}
            {renderWallet(fortmaticIcon, "Fortmatic", () => {
              setAccountsData("");
              connectFortmatic();
            })}
            {renderWallet(phantomIcon, "Phantom", () => {
              setAccountsData("");
              setConnectPhantom(true);
            })}
          </div>
        </div>

        <div className="qrSection">
          {accountsData && (
            <button
              onClick={() => {
                setAccountsData("");
                localStorage.clear();
              }}
              className="disconnectButton"
            >
              Disconnect
            </button>
          )}

          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <h2 className="heading">Scan QR Code to connect to NFTBee</h2>
            {accountsData && (
              <>
                <QRCodeSVG className="qrCode" value={accountsData} />
                <h3 className="heading" style={{ margin: 0, marginTop: "10px" }}>
                  {JSON.parse(accountsData).name}
                </h3>
                <h4 className="heading" style={{ margin: 0, marginTop: "5px" }}>
                  {JSON.parse(accountsData).address}
                </h4>
              </>
            )}
          </div>
        </div>
      </div>

      <MetaMaskWallet
        connect={connectMetaMask}
        onAddressChange={(addressResponse) => {
          setData("MetaMask", addressResponse[0]);
          setConnectMetaMask(false);
          localStorage.clear();
        }}
      />

      <CoinBaseWallet
        connect={connectCoinBase}
        onAddressChange={(addressResponse) => {
          setData("CoinBase", addressResponse[0]);
          setConnectCoinBase(false);
          localStorage.clear();
        }}
      />

      <PhantomWallet
        connect={connectPhantom}
        onAddressChange={(addressResponse) => {
          setConnectPhantom(false);
          setData("Phantom", addressResponse);
          localStorage.clear();
        }}
      />
    </div>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
